<template>
  <v-list-item
    :disabled="somenteLeitura"
    class="d-flex align-center justify-space-between"
  >
    <v-list-item-content>
      <v-list-item-title>{{ role.titulo }}</v-list-item-title>
      <v-list-item-subtitle>{{ role.descricao }}</v-list-item-subtitle>
      <v-tooltip left>
        <span>{{ $t('label.nova_perfil') }}</span>
      </v-tooltip>
    </v-list-item-content>

    <v-text-field
      v-if="valor && role.nome == 'PAGE_DEFAULT_DEFINE'"
      v-model="campoTexto"
      :label="$t('label.informe_pagina_principal')"
      dense
      hide-details
      style="width: 100px;"
    />

    <v-list-item-action class="d-flex align-center" style="gap: 12px;">
      <v-switch
        v-model="valor"
        @click.native="selecionar(role)"
        color="primary"
        :id="`grupo-role-selecionada-${roleIndex}`"
        :name="`grupo-role-selecionada-${roleIndex}`"
      />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'RoleItemLista',
  data() {
    return {
      valor: false,
      campoTexto: '',
    };
  },
  props: {
    somenteLeitura: {
      type: Boolean,
      default: true,
    },
    roleIndex: {
      type: Number,
      default: 0,
    },
    role: {
      type: Object,
      default: () => ({}),
    },
    selecionado: {
      type: Boolean,
      default: false,
    },
    paginaPrincipal: {
      type: String,
      default: '',
    },
  },
  watch: {
    selecionado(val) {
      this.valor = val;
    },
    role() {
      this.valor = this.selecionado;
      this.inicializarCampoTexto();
    },
    campoTexto(novoValor) {
      if (this.role?.nome === 'PAGE_DEFAULT_DEFINE') {
        this.$emit('atualizar-pagina-principal', novoValor);
      }
    },
  },
  methods: {
    selecionar(role) {
      this.$emit('ROLEITEMLISTA_selecionar', role);
    },
    inicializarCampoTexto() {
      if (this.role?.nome === 'PAGE_DEFAULT_DEFINE' && this.paginaPrincipal) {
        this.campoTexto = this.paginaPrincipal;
      }
    },
  },
  mounted() {
    this.valor = this.selecionado;
    this.inicializarCampoTexto();
  },
};
</script>
